<div class="text-h3-bold text-white" i18n>
    CompanyID: <br />
    CRM Solutions <br class="tab:hidden desk:hidden" />
    <span class="text-secondary-color">for everyone</span>
</div>
